import './refresh-shim'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import './index.scss'

import ReactDOM, { Container } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'

import { App } from './app'
import { PostHogAppProvider } from './app/utils/PostHogAppProvider'
import { PostHogIdentify } from './app/utils/PostHogIdentify'
import { BugsnagErrorBoundary } from './app/utils/bugsnag'
import { initialiseMixpanel } from './app/utils/mixpanel'
import { initialiseStore } from './app/store'
import { DarkThemeProvider } from '@qflow/theme'
import { PortalRootNode, SpinnerProvider } from 'portal/lib/primitives'

initialiseMixpanel()
const store = initialiseStore()

const app = (
  <BugsnagErrorBoundary>
    <PostHogAppProvider>
      <Provider store={store}>
        <BrowserRouter>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <DarkThemeProvider>
              <SpinnerProvider>
                <>
                  <PostHogIdentify />
                  <App />
                  <PortalRootNode />
                </>
              </SpinnerProvider>
            </DarkThemeProvider>
          </QueryParamProvider>
        </BrowserRouter>
      </Provider>
    </PostHogAppProvider>
  </BugsnagErrorBoundary>
)

const root = ReactDOM.createRoot(document.getElementById('root') as Container)
root.render(app)
